var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center gap-3 w-100"},[_c('form-candidate',{attrs:{"candidate":_vm.candidate}}),_vm._v(" "),_c('basic-button',{staticClass:"btn-primary",attrs:{"text":_vm.trans('Send Password Reset Link'),"loading":_vm.submitting},on:{"click":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }